import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { setDefaults } from '../../../../slatePlugins/common/utils/setDefaults';
import { BorderShadingMain } from './components/BorderShadingMain';
import { DEFAULT_BORDER_SHADING, ELEMENT_BORDER_SHADING } from './defaults';
import { BorderShadingElement, BorderShadingElementPluginOptions } from './types';

export const renderBorderShadingElementReadOnly =
  (options: BorderShadingElementPluginOptions) =>
  ({ element, children, attributes }: RenderElementProps) => {
    if (element.type === ELEMENT_BORDER_SHADING) {
      const {
        borderShadingElement: { colors, defaultColor },
      } = setDefaults(options, DEFAULT_BORDER_SHADING);
      const { colorKey = defaultColor.key } = element as BorderShadingElement;
      const color = colors.find((i) => i.key === colorKey);

      return (
        <BorderShadingMain
          className="border-shading-element"
          $bgColor={color?.bgColor}
          $borderColor={color?.borderColor}
          {...attributes}
        >
          {children}
        </BorderShadingMain>
      );
    }
    return undefined;
  };
